import {
    FormField,
    Switch
} from "@maysoft/common-component-react"
import {
    Grid,
    FormControlLabel,
    Paper,
    InputAdornment,
    IconButton
} from "@mui/material"
import Strings from "constants/strings"
import { useState } from "react"
import VisibilityIcon from "@mui/icons-material/Visibility"
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff"

type EmailConfig = {
    MailAddress: string
    Credential: string
    Host: string
    Port: string
    EnableSsl: boolean
    SenderName: string
}

type Props = {
    value: EmailConfig
    onChange: (val: EmailConfig) => void
}

const EmailConfigForm = ({ value, onChange }: Props) => {
    const handleChange = (key: keyof EmailConfig, val: any) => {
        onChange({
            ...value,
            [key]: val
        })
    }

    const [showToken, setShowToken] = useState(false)

    return (
        <Paper
            sx={{
                p: 2,
                borderRadius: 2
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <FormField
                        label={Strings.SETTING.EMAIL_CONFIG.ADDRESS}
                        value={value.MailAddress}
                        onChangeValue={(val) =>
                            handleChange("MailAddress", val)
                        }
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormField
                        label={Strings.SETTING.EMAIL_CONFIG.SENDER_NAME}
                        value={value.SenderName}
                        onChangeValue={(val) =>
                            handleChange("SenderName", val)
                        }
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormField
                        label={Strings.SETTING.EMAIL_CONFIG.CREDENTIAL}
                        type={showToken ? "text" : "password"}
                        value={value.Credential}
                        onChangeValue={(val) =>
                            handleChange("Credential", val)
                        }
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={() =>
                                            setShowToken(!showToken)
                                        }
                                    >
                                        {showToken ? (
                                            <VisibilityOffIcon />
                                        ) : (
                                            <VisibilityIcon />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormField
                        label={Strings.SETTING.EMAIL_CONFIG.HOST}
                        value={value.Host}
                        onChangeValue={(val) =>
                            handleChange("Host", val)
                        }
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormField
                        label={Strings.SETTING.EMAIL_CONFIG.PORT}
                        value={value.Port}
                        onChangeValue={(val) =>
                            handleChange("Port", val)
                        }
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={value.EnableSsl}
                                onChange={(e) =>
                                    handleChange(
                                        "EnableSsl",
                                        e.target.checked
                                    )
                                }
                            />
                        }
                        label={Strings.SETTING.EMAIL_CONFIG.SSL}
                    />
                </Grid>
            </Grid>
        </Paper>
    )
}

export default EmailConfigForm